export default {
  advisory: {
    enabled: 'common.enableAdvisoryCurrency',
    optOut: 'common.advisory.enableOptOut',
  },
};
